import React, { useState } from 'react';
import './CoachingMessage.css';

const CoachingMessage = ({ suggestion, isNew }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  // Get priority-based styling
  const getPriorityStyles = (priority) => {
    switch (priority?.toLowerCase()) {
      case 'high':
        return {
          backgroundColor: '#FFE5B4', // Pastel Gold
          color: '#1e1e1e'
        };
      case 'medium':
        return {
          backgroundColor: '#B8D4F0', // Pastel Blue
          color: '#1e1e1e'
        };
      case 'low':
        return {
          backgroundColor: '#E8E8E8', // Pastel Silver
          color: '#1e1e1e'
        };
      default:
        return {
          backgroundColor: '#DEE4FF',
          color: '#5B6DF9'
        };
    }
  };

  const priorityStyles = getPriorityStyles(suggestion.priority);

  // Format timing for display
  const formatTiming = (timeline) => {
    if (!timeline) return null;
    const minutes = Math.floor(timeline / 60);
    const seconds = timeline % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className={`coaching-message ${isNew ? 'new-suggestion' : ''} ${suggestion.reviewed ? 'reviewed' : ''}`}>
      <div className="message-header">
        <div 
          className="message-icon"
          style={priorityStyles}
        >
          {suggestion.reviewed ? (
            <i className="ti ti-check"></i>
          ) : (
            <i className="ti ti-bulb"></i>
          )}
        </div>
        <div className="message-content">
          <div className="message-text">
            <div className="message-text-content">
              {suggestion.suggestion}
            </div>
            {suggestion.reviewed && (
              <span className="reviewed-badge">
                <i className="ti ti-check"></i>
                Completed
              </span>
            )}
          </div>
          <button 
            className="view-more-button"
            onClick={toggleExpanded}
          >
            {isExpanded ? 'Hide more' : 'View more'}
            <i className={`ti ${isExpanded ? 'ti-chevron-up' : 'ti-chevron-down'}`}></i>
          </button>
        </div>
      </div>
      
      {isExpanded && (
        <div className="message-details">
          {suggestion.context && (
            <div className="detail-section">
              <h4>Context</h4>
              <p>{suggestion.context}</p>
            </div>
          )}
          {suggestion.reviewed && suggestion.reviewedContext && (
            <div className="detail-section">
              <h4>Review Context</h4>
              <p>{suggestion.reviewedContext}</p>
            </div>
          )}
          {suggestion.timeline && (
            <div className="detail-section">
              <h4>Timing</h4>
              <p>{formatTiming(suggestion.timeline)}</p>
            </div>
          )}
          {suggestion.priority && (
            <div className="detail-section">
              <h4>Priority</h4>
              <span className={`priority-badge priority-${suggestion.priority.toLowerCase()}`}>
                {suggestion.priority}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CoachingMessage;
